export default [
    {
        name: "address",
        label: "Address",
        type: "string",
    },
    {
        name: "name",
        label: "Name",
        type: "string",
    },
    {
        name: "cityName",
        label: "City",
        type: "string",
    },
    {
        name: "areaName",
        label: "Area",
        type: "string",
    },
    {
        name: "latitude",
        label: "Latitude",
        type: "string",
    },
    {
        name: "longitude",
        label: "Longitude",
        type: "string",
    },
    {
        name: "placeLink",
        label: "Place Link",
        type: "string",
    },
    {
        name: "source",
        label: "Source",
        type: "string",
    },
    {
        name: "createdAt",
        label: "Created At",
        type: "date",
    },
];
